import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpServidor } from '../shared/abstract/http-servidor';
import { Observable } from 'rxjs';

export interface QRCodeAuth {
  imagem: string,
  uuid: string,
  tamanho: number
}

@Injectable()
export class AuthWebProvider extends HttpServidor{

  constructor(http: HttpClient) {
    super(http);
  }

  public buscarQRCode(codAppEmpresa: string): Observable<QRCodeAuth> {
    let form = new HttpParams();
    //classe é imutavel, cada alteração ela retorna uma nova instancia.
    form = form.append('cod_app_empresa', codAppEmpresa);
    return this.get("obtemQRCodeAutenticacaoWeb", form)
  }

  public verificaSePossuiAutorizacaoWeb(uuid: string, imei: string, codAppEmpresa: string): Observable<any> {
    const form = new FormData();
    form.append("uuid", uuid);
    form.append("identificador_dispositivo_web", imei);
    form.append("cod_app_empresa", codAppEmpresa);
    return this.post("verificaSePossuiAutorizacaoWeb", form);
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth-web/auth-web.ts